import React, {useEffect, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { SERVER_URL } from '../constants';
import { formatDate, formatTime, dateToShortDayName } from '../helpers/Helpers';
import { Stack } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import FixedScheduleDatePickerCalendarControl from './FixedScheduleDatePickerCalendarControl';
import FixedScheduleTimeSlotPicker from './FixedScheduleTimeSlotPicker';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import {Box} from '@mui/material';
import OpenDateDynamicQueueDatePickerCalendarControl from './OpenDateDynamicQueueDatePickerCalendarControl';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
    padding: theme.spacing(0),
    },
    '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
    },
}));
  
function OpenDateDynamicQueueDatePicker (props) {
    
    
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === "backdropClick") return; // ignore backdrop clicks
        setOpen(false);
    };

    const fetchSchedulesList = (date) => {
      const token = sessionStorage.getItem("token");
      fetch(SERVER_URL + 'api/mod/list-office-schedules-month/' + props.officeId + '/' + date.format("YYYY-MM"), {
          method: 'GET',
          headers: { 
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'Authorization' : 'Bearer ' + token
          }
      })
      .then(response => response.json())
      .then(data => {
          // console.log("data.data", data.data);
          // if (data.data.length < 1) setMessaage("No schedules");
        //   setSchedules(data.data);
        //   setHighlightedDays(data.data.map(item => dayjs(item.date).date()));
        //   setIsLoading(false);
      })
      .catch(err => console.error(err));
    }

    return(
        <React.Fragment>
            {props.selectedDate && props.selectedScheduleCode? 
            <Typography sx={{ lineHeight: 1.2, textAlign: "center" }} variant="h6">
                {dateToShortDayName(props.selectedDate)}, {formatDate(props.selectedDate)}
            </Typography>
            : null}

            <Button 
                variant="outlined" 
                onClick={handleClickOpen} 
                size="medium">
                <CalendarMonthIcon /> Select Date
            </Button>
            
            <BootstrapDialog
            sx={{
                "& .MuiDialog-container": {
                "& .MuiPaper-root": {
                    width: "auto", // Let content define width
                    maxWidth: "calc(100vw - 32px)", // Prevent overflow on small screens
                    minWidth: "300px", // Optional: set a minimum width
                },
                },
            }}
            onClose={handleClose}
            aria-labelledby="customized-dialog-title"
            open={open}
            >

            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                <Stack
                direction="column"
                justifyContent="center"
                alignItems="flex-start"
                spacing={0}
                >
                    <Typography sx={{ lineHeight: 1.2 }} variant="h6">
                    Pick Preferred Date
                    </Typography>
                    <Typography variant="body1">
                    {props.officeName}
                    </Typography>
                </Stack>
            </DialogTitle>
            
            <DialogContent
                sx={{
                    m: 0,
                    p: 0,
                    overflowX: "auto", // Prevent horizontal scroll
                    maxWidth: "100%",     // Ensure it doesn't exceed parent
                    boxSizing: "border-box", // Respect padding and borders
                }}
            dividers
            >
                <OpenDateDynamicQueueDatePickerCalendarControl 
                    setSelectedDate={props.setSelectedDate} 
                    setSelectedScheduleCode={props.setSelectedScheduleCode} 
                    schedules={props.schedules}
                    setOpen={setOpen}
                />
                <Box sx={{p: 2}}>
                <Typography variant="body2">
                    Available dates are marked with a <AccessTimeIcon sx={{ color: 'darkgrey', fontSize: 20, verticalAlign: "middle"  }} />
                </Typography>
                </Box >
            </DialogContent>

            <DialogActions>
                <Button autoFocus onClick={handleClose}>
                    Close
                </Button>
            </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    );
}

export default OpenDateDynamicQueueDatePicker;